export default "__VITE_ASSET__D1ltCimI__"